import { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../config/firebase";
import { setHyperDXUser, clearHyperDXUser } from "../../services/observability";

type AuthContextType = {
  isAuthenticated: boolean;
  loading: boolean;
  setAuthStatus: (status: boolean) => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const setAuthStatus = (status: boolean) => {
    localStorage.setItem("isAuthenticated", status.toString());
    setIsAuthenticated(status);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const loggedIn = !!user && localStorage.getItem("isAuthenticated") === "true";
      setIsAuthenticated(loggedIn);
      setLoading(false);

      // Update HyperDX user tracking
      if (loggedIn && user) {
        setHyperDXUser(user.uid, user.email || undefined);
      } else {
        clearHyperDXUser();
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, setAuthStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
